import * as React from 'react';

import * as styles from './UndergroundMapSection.css';

export const UndergroundMapSection: React.FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['container']}>{children}</div>
);
